<div class="workspace-page page">
  <div class="top-content">
    <app-tabs [tabs]="workspaceTabs" [activeTab]="activeSection" (tabChange)="setActiveSection($event)" />
    <div class="actions">
      @if (activeSection) {
        <button
          class="primary"
          [policyType]="POLICY_TYPE_SERVICE"
          [claimType]="CLAIM_TYPES['create']"
          (click)="createVisit()"
          appPermission>
          {{ 'pages.workspace.createVisit' | translate }}
        </button>
        @if (activeSection !== 'myReadingRoomApps' || structuralUnitIds.length > 0 || hasGlobalReadingRoomScope) {
          <button
            class="secondary download-excel"
            [disabled]="isExcelDownloading"
            [ngClass]="{ downloading: isExcelDownloading }"
            [policyType]="POLICY_TYPE_SERVICE"
            [claimType]="CLAIM_TYPES['read']"
            (click)="getExcelFile()"
            appPermission>
            @if (!isExcelDownloading) {
              <img class="icon" src="assets/images/download-excel.svg" alt="download-excel.svg" />
              {{ 'pages.user.saveExcel' | translate }}
            } @else {
              <div class="spinner-wrapper">
                <div class="spinner"></div>
              </div>
            }
          </button>
        }
      }
    </div>
  </div>
  <div class="content">
    @if (activeSection === 'myApps') {
      <app-table
        #myAppsTable
        [columns]="myAppsTableColumns"
        [endpoint]="apiPathMyApps"
        [flatTopBorder]="true"
        [sortBy]="'id'"
        [policyType]="POLICY_TYPE_MY_WORKSPACE"
        [claimType]="CLAIM_TYPES['workspaceAllServiceSubmissions']"
        [showTooltipText]="true"
        [isEntryPathForSubmittion]="true"
        [sortDirection]="'desc'"
        [sortBy]="'submittedOn'"
        [defaultFilters]="{ responsibleUserId: userId, attendanceStatuses: 'Unknown' }"
        appPermission
        [tableTooltipText]="'myWorkspaceMySubmissionsTable'"
        />
    } @else if (activeSection === 'myReadingRoomApps') {
      <app-table
        #myReadingRoomAppsTable
        [columns]="appTableColumns"
        [endpoint]="apiPath"
        [flatTopBorder]="true"
        [sortBy]="'id'"
        [policyType]="POLICY_TYPE_MY_WORKSPACE"
        [claimType]="CLAIM_TYPES['workspaceAllServiceSubmissions']"
        [showTooltipText]="true"
        [isEntryPathForSubmittion]="true"
        [sortDirection]="'desc'"
        [sortBy]="'submittedOn'"
        [defaultFilters]="{ structuralUnitIds: this.structuralUnitIds }"
        [showEmpty]="!hasGlobalReadingRoomScope && structuralUnitIds.length === 0"
        appPermission
        [tableTooltipText]="'myWorkspaceStructuralUnitSubmissionsTable'"
        />
    } @else if (activeSection === 'allApps') {
      <app-table
        #allAppsTable
        [columns]="appTableColumns"
        [endpoint]="apiPath"
        [flatTopBorder]="true"
        [sortBy]="'id'"
        [policyType]="POLICY_TYPE_MY_WORKSPACE"
        [claimType]="CLAIM_TYPES['workspaceAllServiceSubmissions']"
        [showTooltipText]="true"
        [isEntryPathForSubmittion]="true"
        [sortDirection]="'desc'"
        [sortBy]="'submittedOn'"
        appPermission
        [tableTooltipText]="'myWorkspaceAllSubmissionsTable'"
        />
    }
  </div>
</div>
